import attributeKeysModule from './attribute_keys'
import finalizedDocumentsModule from './finalized_documents'
import usersModule from './users'
import userGroupsModule from './user_groups'

export default {
  namespaced: true,
  modules: {
    attributeKeys: attributeKeysModule,
    finalizedDocuments: finalizedDocumentsModule,
    users: usersModule,
    userGroups: userGroupsModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
}
